export default __webpack_public_path__ + "static/media/120ac.61304f32.png";